"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _react = _interopRequireDefault(require("react"));
var _RestartButton = _interopRequireDefault(require("./RestartButton.styles"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ReactSVGIcon = (0, _component.default)(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const RestartButton = _ref => {
  let {
    lang,
    onRestart
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = (0, _RestartButton.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default
    }
  });
  const restart = () => {
    onRestart();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.button, "mco-bus-stops-restart-button"),
    onClick: restart
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    src: REACT_APP_PATH + "/img/icons/bus-stops/restart.svg"
  }), /*#__PURE__*/_react.default.createElement("span", null, l("reactBusStops.buttons.restart")));
};
var _default = exports.default = RestartButton;